import React from "react";
import "./Vision_Section.css";

const Vision_Section = () => {
  return (
    <section className="vision-section why-trust-section">
      <div className="vision-container">
        <div class="section-header text-center">
          <h2>Our Vision</h2>
          <p>
            {" "}
            We believe strong cities are built on strong Loconexions.
          </p>
        </div>

        <p className="vision-text">
          <strong>Loconex</strong> exists to digitally empower every
          citizen, vendor, and institution — creating a smarter, safer, and more
          connected city.
        </p>

        <div className="vision-highlight">
          One City • One Platform • For Everyone
        </div>
      </div>
    </section>
  );
};

export default Vision_Section;
